import React from 'react';
import { LogoIcon, LogoText } from './Logo.styles';

import CallOnLogo from '../../images/logo.png';
import CallOnText from '../../images/callOnWhite.png';

const Logo = () => {
    return (
        <>
            <LogoIcon src={CallOnLogo} alt='Logo' />
            <LogoText src={CallOnText} alt='Logo' />
        </>
    )
}

export default Logo;